// index.js

import React, { createContext, useContext } from "react";
import ReactDOM from 'react-dom/client';
import UserStore from "./store/UserStore";
import { CartProvider } from "./store/CartContext";
import App from "./App";
import './index.css';
import { NotificationProvider } from "./store/NotificationContext";
import { ChatStore } from "./store/chat/ChatStore";
import { AiChatStore } from "./store/chat/AiChatStore";

export const Context = createContext({});

export const useStores = () => {
    const context = useContext(Context);

    if (context === null) throw new Error("Call hook outside context");

    return context;
}
// 🔥 Очищаем localStorage, если там мусор
const cleanStorage = () => {
    try {
        const storedUser = JSON.parse(localStorage.getItem('user'));
        if (!storedUser || typeof storedUser !== 'object' || !storedUser.id || !storedUser.email || !storedUser.role) {
            console.warn("Невалидные данные пользователя, очищаем localStorage");
            localStorage.removeItem('user');
        }
    } catch (error) {
        console.warn("Ошибка чтения localStorage, очищаем:", error.message);
        localStorage.removeItem('user');
    }
};

cleanStorage(); // ✅ Запускаем очистку перед созданием стора
const userStore = new UserStore();



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    // <React.StrictMode>
    <NotificationProvider>
        <Context.Provider value={{
            user: userStore, // ✅ Передаём один и тот же инстанс
            chat: new ChatStore(),
            aiChat: new AiChatStore(),
        }}>
            <CartProvider>
                <App />
            </CartProvider>
        </Context.Provider>
    </NotificationProvider>
    // </React.StrictMode>
);